$ = jQuery.noConflict();

var Press = {
	init:function(){
		console.log("________PRESS INIT__________");

		$(window).resize(function(){
			Press.resize();
		});
		Press.resize();



	},
	resize:function(){

		var _slide_to_show = 5;

		if ($(".presse-container .press-list").hasClass('slick-initialized')) {
			$(".presse-container .press-list").slick('unslick');
		}


		switch ($(".presse-logo").css("margin-left")){
			case "40px":
				/*console.log("CAS 1");*/
				_slide_to_show = 5;
				break;
			case "35px":
				/*console.log("CAS 2");*/
				_slide_to_show = 5;
				break;
			case "30px":
				/*	console.log("CAS 3");*/
				_slide_to_show = 1;
				Press.create_slick();
				break;
																								}
	},
	create_slick:function(){

		$(".presse-container .press-list").slick({
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth:true,
			touchThreshold:500,
			infinite: false,
			centerMode:true,
			initialSlide:2,
			mobileFirst:true
		})
	}
}
/*
$(document).ready(function(){
	console.log("!!!!!!!! PRESS READY")
	if($(".presse-container").length){
		Press.init();
	}
});*/